const followImage = () => {
	const projects = document.querySelector(".projects");
	if (!projects) return;
	const items = projects.querySelectorAll(".project__wrapper");
	if (!items) return;
	items.forEach((item) => {
		const images = item.querySelectorAll(".project__image");
		item.addEventListener("mousemove", (ev) => {
			images.forEach((image) => {
				console.log(image);
				image.style.transform = `translateX(${ev.offsetX}px) translateY(-50%)`;
			});
		});
	});
};

export { followImage };
